import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Checkbox,
} from '@mui/material';
import  {useEffect, useState} from 'react';
import {X} from 'lucide-react';

function FetchLocationModel({isOpen, setIsOpen, pinCodes,locations,setLocations,handleChatResponse}) {
  const [error, setError] = useState('');

  
  useEffect(() => {
    const pinCodesArray = transformToLocations(pinCodes);
    setLocations(pinCodesArray);
    setError('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pinCodes]);

  function transformToLocations(dataArray) {
    return dataArray.map(item => ({
      zip: item.pincode,
      selected: false,
    }));
  }

  const handleSelect = index => {
    const newLocations = [...locations];
    newLocations[index].selected = !newLocations[index].selected;
    setLocations(newLocations);

    setError("")
  };

  function extractPincodes(locations) {
  return locations.map(item => item.zip);
}
  const handleGetWeather = () => {
    const selectedLocations = locations.filter(loc => loc.selected);
    if (selectedLocations.length === 0) {
      setError('Please select at least one location.');
      return;
    }
    setError('');
    const payload = {
      pincodes:extractPincodes(selectedLocations)
    }
    
    handleChatResponse({payload})
  };

  return (
    <Dialog
      open={isOpen}
      maxWidth="sm"
      fullWidth
      PaperProps={{className: 'rounded-[16px]'}}>
      <DialogContent
        className="flex flex-col gap-6 p-8 max-h-[90vh] overflow-y-auto relative"
        onInteractOutside={e => e.preventDefault()}>
        {/* Close Button */}
        <IconButton
          onClick={() => setIsOpen(false)}
          className="absolute top-4 right-4"
          size="small">
          <X className="w-5 h-5" />
        </IconButton>

        <div className="text-left">
          <Typography
            variant="h5"
            className="font-hel font-normal text-[24px] leading-[34px]">
            Fetch Your Data to See Weather Forecast
          </Typography>
          <Typography className="mt-1 text-[#000000BF] font-hel font-normal text-sm leading-[20px]">
            Select your zip code to get that area's worst weather conditions for
            the next 10 days.
          </Typography>
        </div>

        {/* Grid of locations with checkbox */}
        <div className="grid gap-3 grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
          {locations.map((loc, index) => (
            <div
              key={index}
              className="flex min-h-[56px] items-center justify-between border border-[#E0E0E0] rounded-[13px] px-4">
              <Typography className="text-black text-[16px] leading-[26px] font-normal font-hel">
                {loc.zip}
              </Typography>
              <Checkbox
                checked={loc.selected}
                onChange={() => handleSelect(index)}
                color="success"
              />
            </div>
          ))}
        </div>

        {error && <Typography className="text-red-500">{error}</Typography>}

        {/* Buttons */}
        <div className="flex flex-row gap-[10px] items-center justify-center sm:justify-end mt-4">
          <button
          type='button'
            onClick={() =>
              setLocations(locations.map(loc => ({...loc, selected: true})))
            }
            className=" text-sm leading-[20px] md:text-[16px] md:leading-[24px] font-medium font-inter text-black border border-[#00000033] py-[10px] px-[25px] bg-white rounded-[8px]">
            Select All
          </button>
          <button
          type='button'
            onClick={handleGetWeather}
            className="text-sm leading-[20px] md:text-[16px] md:leading-[24px] font-medium font-inter text-white py-[10px] px-[25px] bg-[#1B5C29] rounded-[8px]">
            Get Weather Forecast
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default FetchLocationModel;
